import { selectEntities, selectAll, select, sortBy } from './applicationSelectors';

export const selectAppSiteEntities = selectEntities('appSites');
export const selectAppSites = selectAll(selectAppSiteEntities);
export const selectAppSite = select(selectAppSiteEntities);
export const selectOrderedAppSites = sortBy(selectAppSites, 'name');
export const selectAppStreamAppSiteEntities = selectEntities('appStreamAppSites');
export const selectAppStreamAppSites = selectAll(selectAppStreamAppSiteEntities);
